"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var hexToRGBa_1 = __importDefault(require("../utils/hexToRGBa"));

var getPalette = function getPalette(actionPalette, reversed) {
  var palette = {
    background: actionPalette.background,
    border: actionPalette.border || actionPalette.background,
    text: actionPalette.text
  }; // when reverse is true then override other properties

  if (reversed) {
    return Object.assign(palette, actionPalette.reversed);
  }

  return palette;
};

var createPaletteProps = function createPaletteProps(actionPalette, reversed) {
  var palette = getPalette(actionPalette, reversed);
  return {
    ':hover': {
      boxShadow: "0 0 0 4px " + hexToRGBa_1.default(palette.border, 0.16)
    },
    ':focus': {
      boxShadow: "0 0 0 4px " + hexToRGBa_1.default(palette.border, 0.16)
    },
    background: palette.background,
    border: "2px solid " + palette.border,
    color: palette.text
  };
};

var createGhostPallete = function createGhostPallete(actionPalette) {
  var palette = getPalette(actionPalette, true);
  return {
    ':hover': {
      boxShadow: "0 0 0 4px " + hexToRGBa_1.default(palette.border, 0.16)
    },
    ':focus': {
      boxShadow: "0 0 0 4px " + hexToRGBa_1.default(palette.border, 0.16)
    },
    background: 'none',
    border: 0,
    color: palette.text
  };
};

var getActionProps = function getActionProps(palette, action, reversed) {
  switch (action) {
    case 'primary':
      {
        return createPaletteProps(palette.primary, reversed);
      }

    case 'secondary':
      return createPaletteProps(palette.secondary, reversed);

    case 'tertiary':
      return createPaletteProps(palette.tertiary, reversed);

    case 'danger':
      return createPaletteProps(palette.danger, reversed);

    case 'ghost':
      return createGhostPallete(palette.secondary);

    default:
      return createPaletteProps(palette.secondary, true);
  }
};

var getFontWeight = function getFontWeight(theme, action) {
  switch (action) {
    case 'primary':
      {
        return theme.weight.bold;
      }

    case 'secondary':
      return theme.weight.normal;

    case 'tertiary':
      return theme.weight.light;

    case 'ghost':
      return theme.weight.light;

    case 'danger':
      return theme.weight.normal;

    default:
      return theme.weight.normal;
  }
};

exports.Button = styled_components_1.default.button(function (props) {
  var _a = props.action,
      action = _a === void 0 ? 'secondary' : _a,
      disabled = props.disabled,
      loading = props.loading,
      theme = props.theme,
      _b = props.reversed,
      reversed = _b === void 0 ? false : _b,
      _c = props.width,
      width = _c === void 0 ? 'auto' : _c,
      _d = props.tight,
      tight = _d === void 0 ? false : _d;
  var disabledState = loading || disabled;
  var actionTheme = disabledState ? createPaletteProps(theme.palette.disabled, reversed) : getActionProps(theme.palette, action, reversed);
  return __assign(__assign({}, actionTheme), {
    fontFamily: theme.fontText,
    fontWeight: getFontWeight(theme, action),
    // global component props
    borderRadius: theme.component.radius,
    fontSize: theme.component.fontSize,
    height: theme.component.height,
    margin: (!tight && theme.component.margin) + " 0px ",
    padding: "0px " + theme.component.padding,
    // component specific css
    cursor: disabledState ? 'not-allowed' : 'pointer',
    outline: 0,
    // width can be managed as a property
    width: width,
    // some of these props should be top driven
    alignItems: 'center',
    justifyContent: 'center',
    display: 'inline-flex'
  });
});
/**
 * Button
 *
 * @component
 */

exports.default = exports.Button;